var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container d-flex flex-column justify-content-center text-center py-5 px-20"},[_c('h1',[_c('span',{staticClass:"text-primary text-gradient"},[_vm._v("\n      "+_vm._s(_vm.error.statusCode === 404
          ? 'Halaman Tidak Ditemukan'
          : 'Terjadi Kesalahan')+"\n    ")])]),_vm._v(" "),_c('NuxtLink',{attrs:{"to":"/"}},[_vm._v("Kembali ke beranda")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }